<script setup lang="ts">
  import { onMounted } from "vue";
  import { useRouter } from "vue-router";
  import { IconLogo, Avatar, Spinner, Text } from "@ui-kit";
  import { StatusBar } from "@src/components";
  import { useProfileOptions } from "@src/hooks";
  import { useUserInfoStore } from "@src/store";

  const { profile } = useProfileOptions();
  const { push } = useRouter();
  const userInfoStore = useUserInfoStore();

  onMounted(() => {
    setTimeout(() => push("main"), 2000);
  });
</script>

<template>
  <div class="welcome-page">
    <StatusBar />
    <div class="welcome-page__logo">
      <IconLogo size="fill: var(--sf-base-text-primary)" />
    </div>
    <div class="welcome-page__info">
      <Avatar size="xl" :first-name="profile?.current_user.first_name" :last-name="profile?.current_user.last_name" />
      <div class="welcome-page__details">
        <Text font="body-bold-18" data-testid="welcome-user-name">{{
          $t("Добро пожаловать") + "," + profile?.current_user.first_name + "!"
        }}</Text>
        <Text v-if="userInfoStore.shop?.title" data-testid="welcome-user-shop">{{
          $t("Ваш магазин") + ":" + " " + userInfoStore.shop?.title
        }}</Text>
      </div>
      <Spinner />
    </div>
  </div>
</template>

<style scoped>
  .welcome-page {
    display: flex;
    flex-direction: column;
    flex: 1;
    background-color: var(--sf-base-background-white);
  }

  .welcome-page__logo {
    display: flex;
    margin-top: 12px;
    justify-content: center;
    align-items: center;
  }

  .welcome-page__info {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    margin: 0 16px;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }

  .welcome-page__details {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .welcome-page__details :deep(.text) {
    white-space: break-spaces;
    text-align: center;
  }
</style>
